var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.327,
    height: 51.326,
    viewBox: "0 0 51.327 51.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cddeec;}.b{fill:#bdd0df;}.c{fill:#abe9df;stroke:#f1f3fb;stroke-width:6px;}.d{fill:#2196f3;}.e{fill:#48b5a4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M35.256.012H13.107a1.006,1.006,0,0,0-.713.294L.313,12.387a1.007,1.007,0,0,0-.294.713V43.3A1.007,1.007,0,0,0,1.026,44.31H35.256A1.007,1.007,0,0,0,36.263,43.3V1.019A1.007,1.007,0,0,0,35.256.012Z",
    transform: "translate(-0.018 -0.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.474.085a1.007,1.007,0,0,0-1.1.217L.3,12.383a1.007,1.007,0,0,0,.713,1.72H13.089A1.007,1.007,0,0,0,14.1,13.1V1.015A1.006,1.006,0,0,0,13.474.085Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.075,0A11.075,11.075,0,1,1,0,11.075,11.075,11.075,0,0,1,11.075,0Z",
    transform: "translate(26.178 26.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M139.093,149.345h-4.027a1.007,1.007,0,0,0-1.007,1.007v9.464a5.112,5.112,0,0,0-2.014-.4c-2.259,0-4.027,1.327-4.027,3.02s1.768,3.02,4.027,3.02,4.027-1.327,4.027-3.02V151.359h3.02a1.007,1.007,0,1,0,0-2.014Z",
    transform: "translate(-115.935 -135.242)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.231 32.598)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M385.026,331.719a.934.934,0,0,1-1.007-.836V320.847a1.024,1.024,0,0,1,2.014,0v10.035A.934.934,0,0,1,385.026,331.719Z",
    transform: "translate(-380.005 -320.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M350.54,326.045a1.007,1.007,0,0,1-.713-.294l-3.314-3.316-3.314,3.314a1.007,1.007,0,0,1-1.424-1.423L345.8,320.3a1.007,1.007,0,0,1,1.424,0l4.027,4.027a1.007,1.007,0,0,1-.713,1.72Z",
    transform: "translate(-341.492 -320.004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.28f210868b5e3e94fb0775c18bf95786.svg";
export { ForwardRef as ReactComponent };